import { FormSection } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSection';
import { IntegrationConnectorForm } from '@organisms';
import { FormSectionSummary } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSectionSummary';
import { Controller, useWatch } from 'react-hook-form';
import { IntegrationConfigAppModelV2 } from '@api';
import { Control } from 'react-hook-form/dist/types/form';
import { ReactNode } from 'react';
import { IntegrationConfigFormPayload } from '@Integrations/organisms/IntegrationConfigForm/Provider';
import { ConnectorView } from '@Integrations/organisms/IntegrationConfigForm/ConfigInfo';
import { ErrorPage } from '@pages';

export function ConnectorFormSection({
  config,
  control,
  actions,
  expanded,
  isEdit,
}: {
  config: IntegrationConfigAppModelV2;
  control: Control<IntegrationConfigFormPayload>;
  actions?: ReactNode;
  expanded: boolean;
  isEdit?: boolean;
}) {
  const { provisioner_id } = useWatch({ control });
  if (isEdit) {
    return (
      <FormSection
        expanded={expanded}
        summary={
          <FormSectionSummary
            title="Apono connector"
            tooltip="The Apono connector separates the Apono app from your environment for security purposes."
          />
        }
        actions={expanded && actions}
      >
        <>{provisioner_id && <ConnectorView connectorId={provisioner_id} />}</>
      </FormSection>
    );
  }

  return (
    <FormSection
      expanded={expanded}
      summary={
        <FormSectionSummary
          title="Apono connector"
          tooltip="The Apono connector separates the Apono app from your environment for security purposes."
        />
      }
      actions={expanded && actions}
    >
      {isEdit ? (
        <>
          {provisioner_id ? (
            <ConnectorView connectorId={provisioner_id} />
          ) : (
            <ErrorPage errorCode={404} errorMessage="Connector not found" />
          )}
        </>
      ) : (
        <Controller
          name="provisioner_id"
          control={control}
          render={({ field }) => (
            <IntegrationConnectorForm config={config} connectorId={field.value} onConnectorIdChange={field.onChange} />
          )}
        />
      )}
    </FormSection>
  );
}
